module.exports = __webpack_public_path__ + "img/Ahex.55ff8768.png";